import PayerNameWithInfo from '../../PayerNameWithInfo';

export const newPayerColumns = [
  {
    field: 'id',
    headerName: 'ID',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    minWidth: 100,
    flex: 1
  },
  {
    field: 'name',
    headerName: 'Name',
    cellRenderer: (params) => <PayerNameWithInfo payer={params.data} />,
    flex: 2
  }
];
